import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const getListPersonsByBranch = async ({ sucursal_id, token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.PERSONA.LISTA_POR_SUCURSAL}${sucursal_id}`, extraHeaders: { token: token } });;
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default getListPersonsByBranch;